enum TrackingIdEnum {
	sessionIdKey = 'session_id',
	longTermIdKey = 'long_term_id',
	planningIdKey = 'planning_id',
	ipexIdKey = 'ipex_id'
}

export default TrackingIdEnum;
